import React from "react";
import { LEGAL_PATHS } from "./legalRules";

const FooterLink = ({ to, children }) => (
  <a
    href={to}
    target="_blank"
    rel="noopener noreferrer"
    className="text-brand hover:underline"
  >
    {children}
  </a>
);

/** The legal links and company line shown under the sign-up forms and the legal pages. */
const LegalFooter = ({ className = "" }) => (
  <div
    className={`text-xs text-ui-text-muted space-y-1 ${className}`}
    data-testid="legal-footer"
  >
    <p className="m-0">
      <FooterLink to={LEGAL_PATHS.terms.fr}>
        Conditions d'utilisation
      </FooterLink>
      {" / "}
      <FooterLink to={LEGAL_PATHS.terms.en}>Terms of Service</FooterLink>
      {" · "}
      <FooterLink to={LEGAL_PATHS.privacy.fr}>
        Politique de confidentialité
      </FooterLink>
      {" / "}
      <FooterLink to={LEGAL_PATHS.privacy.en}>Privacy Policy</FooterLink>
    </p>
    <p className="m-0">
      HAJEX Bolt est un service de HAJEX Inc. / HAJEX Bolt is a service of HAJEX
      Inc. 10051-10061, rue Mirabeau, Anjou (Québec) H1J 1T7, Canada
    </p>
    <p className="m-0">
      Vie privée / Privacy:{" "}
      <a
        href="mailto:info@hajexbolt.com?subject=Privacy"
        className="text-brand hover:underline"
      >
        info@hajexbolt.com
      </a>{" "}
      (objet « Vie privée » / subject "Privacy")
    </p>
  </div>
);

export default LegalFooter;
